import React, { FC, FunctionComponent, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  CardItemProps,
  DeleteUserObj,
  UpdateUserObj,
} from "../../../shared/interfaces/components/card.interface";
import { User } from "../../../shared/interfaces/model/user.interface";
import * as actions from "../../../store/addTenantUser/actions";
import {
  deleteUserRowRequest,
  updateUserRowRequest,
  getTenantUserListRequest,
} from "../../../store/tenantUserList/action";
import { TestProduct } from "../../../shared/interfaces/model/product.interface";
import { motion, AnimatePresence } from "framer-motion";
import { UserPlus, UserCog, Trash2, User2, X, Delete } from "lucide-react";
import InviteModal from "./InviateModal";
import UserListItem from "./UserListItem";
import ModifyMemberModal from "./ModifyMemberModal";
import SuccessModal from "./SuccessModal";
import ErorrModal from "./ErorrModal";
import InviateMemberModal from "./InviateMemberModal";
import { useNavigate } from "react-router-dom";



let responseCode = 0;
let responseData = "";

export const recoverResponseCode = async (code: number) => {
  responseCode = code;
};

export const recoverResponseData = async (message: string) => {
  responseData = message;
};

interface InviteMemberCardItemProps {
  tenantDocId: string;
  displayName: string;
  userList: User[];
  id: string;
  organizationEmail: string;
  tenantProducts: string[];
  testProducts: TestProduct[];
  location?: any;
}

// Custom Modal Component

const InviteMemberCard: FC<InviteMemberCardItemProps> = ({
  tenantDocId,
  displayName,
  userList,
  id,
  organizationEmail,
  tenantProducts,
  testProducts,
}: CardItemProps) => {
  // dispatch an action
  const dispatch = useDispatch();
  const navigate = useNavigate();
  // reducer data
  const { tenantid, numEmployees, usersTenant, deleteUserRes, isDeleteUserRowOk, isUpdateUserRowOk } = useSelector(
    (state: any) => ({
      tenantid: state.tenantsReducer.detailsTenant.tenantId,
      numEmployees: state.tenantsReducer.detailsTenant.numberEmployees,
      usersTenant: state.tenantUserListReducer.tenantsUserList.users.length,
      deleteUserRes: state.tenantUserListReducer.deleteUserRes,
      isDeleteUserRowOk: state.tenantUserListReducer.isDeleteUserRowOk,
      isUpdateUserRowOk: state.tenantUserListReducer.isUpdateUserRowOk,
    })
  );
  const [formData, setFormData] = useState({
    email: "",
    name: "",
    surname: "",
    products: [],
  });

  const [selectedUserRow, setSelectedUserRow] = useState<User | null>(null);
  const [showSuccessModal, setShowSuccessModal] = useState(false);
  const [showErrorModal, setShowErrorModal] = useState(false);
  const [showInviteModal, setShowInviteModal] = useState(false);
  const [errorModalContent, setErrorModalContent] = useState<{
    msg: string;
    children: React.ReactNode | null;
  }>({
    msg: "",
    children: null,
  });
  const [successModalContent, setSuccessModalContent] = useState<{
    msg: string;
    children: React.ReactNode | null;
  }>({
    msg: "",
    children: null,
  });
  //   const []

  // hooks
  const [showModifyModal, setShowModifyModal] = useState(false);
  const [showDelete, setShowDelete] = useState(false);
  const [loading, setLoading] = useState(false);
  
  const [selectedProducts, setSelectedProducts] = useState<string[]>([]);
  const [errorMessage, setErrorMessage] = useState("");



  

  useEffect(() => {
    if (isDeleteUserRowOk === true) {
        setSuccessModalContent({
            msg: "Membro eliminato con successo",
            children: null,
        });
      setShowSuccessModal(true);
    } else if (isDeleteUserRowOk === false) {
        setErrorModalContent({
            msg: "Errore durante l'eliminazione del membro",
            children: null,
        });
        setShowErrorModal(true);
    }
  }, [isDeleteUserRowOk]);


  useEffect(() => {
    if (isUpdateUserRowOk === true) {
        setSuccessModalContent({
            msg: "Membro aggiornato con successo",
            children: null,
        });
      setShowSuccessModal(true);
    } else if (isUpdateUserRowOk === false) {
        setErrorModalContent({
            msg: "Errore durante l'aggiornamento del membro",
            children: null,
        });
        setShowErrorModal(true);
    }
  }, [isUpdateUserRowOk]);

  

  

  const deleteUserRow = () => {
    if (selectedUserRow?.email) {
        const deleteUserObj: DeleteUserObj = {
        tenantId: tenantDocId,
        usermail: selectedUserRow?.email || "",
      };
      dispatch(deleteUserRowRequest(deleteUserObj));
    } else {
      setErrorModalContent({
            msg: "Seleziona un membro da eliminare",
            children: null,
        });
        setShowErrorModal(true);
    }
  };

  const updateUserRow = (newEmail: string) => {
    const updateUserObj: UpdateUserObj = {
        tenantId: tenantDocId,
        usermail: selectedUserRow?.email || "",
        newMail: newEmail,
    };
    dispatch(updateUserRowRequest(updateUserObj));
    setFormData({ ...formData, email: newEmail });
  };

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      className="bg-white rounded-lg  p-6 border border-slate-200 "
    >
      {/* Header */}
      <div className="flex justify-between items-center mb-6">
        <h3 className="text-2xl font-bold text-gray-800">{displayName}</h3>
        <motion.button
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
          className="bg-[#0c1d46] hover:bg-sky-700 text-white px-4 py-2 rounded-lg flex items-center gap-2 transition-colors"
          onClick={() => {
            if (userList.length >= numEmployees) {
              setErrorModalContent({
                msg: "Hai raggiunto il numero massimo di membri consentiti per questo tenant.",
                children: (
                  <p className="text-gray-500 text-sm text-center mb-5">Contattare il supporto per aumentare il numero di membri.</p>
                )
              });
              setShowErrorModal(true);
            } else {
              setShowInviteModal(true);
            }
            // // emailChange2("");
            // showModal(1);
            // setAlreadyExist(false);
          }}
        >
          <UserPlus size={20} />
          <span>Invite Member</span>
        </motion.button>
      </div>

      {/* User List */}
      <motion.ul className="space-y-3 mt-6">
        {userList.length > 0 &&
          userList.map((user: User) => (
            <UserListItem
              key={user.uid}
              user={user}
              testProducts={testProducts}
              isOrganizationEmail={user.email === organizationEmail}
              onEdit={(user) => {
                setSelectedUserRow(user);
                setShowModifyModal(true);
              }}
              onDelete={(user) => {
                setSelectedUserRow(user);
                setShowDelete(true);
                // setCurrentUid(user.uid);
                // emailChange2(user.email);
                // showModal(3);
              }}
            />
          ))}
      </motion.ul>

      {/* Delete Modal */}
      <InviteModal
        isOpen={showDelete}
        onClose={() => {
          setShowDelete(false);
          setSelectedUserRow(null);
        }}
        title="Are you sure?"
        icon={<Trash2 size={20} className="mr-2" />}
        footerChildren={
          <>
            <motion.button
              onClick={() => setShowDelete(false)}
              className="px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50"
            >
              Cancel
            </motion.button>
            <motion.button
              onClick={deleteUserRow}
              className="px-4 py-2 bg-red-500 text-white rounded-lg hover:bg-red-600"
            >
              Delete Member
            </motion.button>
          </>
        }
      >
        <div className="space-y-6">
          <p>Are you sure you want to delete this member?</p>
          {selectedUserRow && (
            <>
              <p className="text-red-500 font-medium flex items-center gap-2 flex-wrap">
                <span className="flex items-center gap-2 bg-red-500 p-2 rounded-full shadow-sm backdrop-blur-sm">
                  <User2 size={20} className="text-white" />
                </span>
                {selectedUserRow.displayName}
                <Delete size={20} className="ml-2" />
              </p>
            </>
          )}
          <p className="text-gray-500">
            This action is irreversible and cannot be undone.
          </p>
        </div>
      </InviteModal>

      

      {/* Success Modal */}
      <SuccessModal
        show={showSuccessModal}
        setShow={(v) =>  {
            setShowSuccessModal(v);
            // refresh the route to get the latest data
            navigate(0);
        }}
        description={successModalContent.msg}
      >
        {successModalContent.children}
      </SuccessModal>

      {/* Error Modal */}
      <ErorrModal
        show={showErrorModal}
        setShow={setShowErrorModal}
        emailError={errorModalContent.msg}
      >
        {errorModalContent.children}
      </ErorrModal>

      {/* Invite Member Modal */}
      <InviateMemberModal
        showInviteModal={showInviteModal}
        onClose={() => setShowInviteModal(false)}
        loading={loading}
        tenantProducts={tenantProducts}
        testProducts={testProducts}
        selectedProducts={selectedProducts}
        tenantid={tenantid}
        formData={formData}
        userList={userList}
        setFormData={setFormData}
        onAddClick={() => {
          setShowSuccessModal(true);
        }}
      />

      {/* Modify Member Modal */}
      {showModifyModal && (
        <ModifyMemberModal
          isOpen={showModifyModal}
          onClose={() => {
            setShowModifyModal(false);
            setSelectedUserRow(null);
          }}
          email={selectedUserRow?.email || ""}
          onUpdate={(email) => {
            
            setShowModifyModal(false);
            updateUserRow(email);
          }}
          onDelete={() => {
            setShowModifyModal(false);
          }}
          loading={loading}
          errorMessage={errorMessage}
        />
      )}
    </motion.div>
  );
};

export default InviteMemberCard;
